import type { HttpHeaders } from '@iconik-io/core/src/http/generic_http_transport';
import type { EndpointError } from '@iconik-io/iconik-api/src/client/response';

export type SerializableError = {
  name: string;
  message: string;
  stack: string | undefined;
};

export function fromError(error: Error): SerializableError {
  return {
    name: error.name,
    message: error.message,
    stack: error.stack,
  };
}

export type SerializableEndpointError = SerializableError & {
  status: number;
  statusText: string | undefined;
  headers: HttpHeaders;
  bodyErrors: string[];
};

export function fromEndpointError(
  error: EndpointError,
): SerializableEndpointError {
  return {
    ...fromError(error),
    status: error.response.status,
    statusText: error.response.statusText,
    headers: error.response.headers,
    bodyErrors: error.response.body?.errors ?? [],
  };
}
